import React from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  awardPaper: {
    borderRadius: 0,
    maxHeight: "85vh",
    maxWidth: "950px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "unset",
      maxHeight: "unset"
    }
  },
  awardDialogContent: {
    flex: "unset",
    overflow: "hidden",
    padding: "0px !important",
    overflowY: "scroll"
  },
  awardClose: {
    position: "absolute",
    right: 0
  }
}));

export default function AwardDetailView(props) {
  const theme = useTheme();
  const classes = useStyles();
  const { dialogContent, maxWidth, fullWidth, open, onClose } = props;

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="modal"
      classes={{ paper: classes.awardPaper }}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle id="modal-title" className={clsx(classes.awardClose)}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className={clsx(classes.awardDialogContent, {
          [classes.scrollable]: fullScreen
        })}
      >
        {dialogContent}
      </DialogContent>
    </Dialog>
  );
}
